import React, { Component } from 'react';
import profileInfoFakeAvatar from '../../../../../shared/images/profile-info-fake-avatar.png';
import { PermissionPipe } from '../../../../../shared/pipes/PermissionPipe';
import './UserInfo.scss';
import {
    extractPermissionsForUser,
    permissionsToHideArray
} from '../../../../../shared/models/permissions';
import { ContentBox } from '../../../../../shared/content-box/ContentBox';
import Switch from '@material-ui/core/Switch';
import * as _ from 'lodash';

export class UserInfo extends Component {
    makeUserInfoContent = () => {
        const { loaded, user } = this.props;
        const permissions = extractPermissionsForUser(user).filter(
            permission => !_.includes(permissionsToHideArray, permission)
        );

        return loaded ? (
            <div className={'user-info-container'}>
                <div className={'user-image'}>
                    <img alt={'Player Avatar'} src={profileInfoFakeAvatar} />
                </div>
                <div className={'user-info'}>
                    <div className={'user-header'}>
                        <span className="player-name">
                            {user.firstName + ' ' + user.lastName}
                        </span>
                        <span className="player-id-profile">{user.id}</span>
                    </div>
                    <div className={'user-data'}>
                        <div className={'user-column'}>
                            <span className={'user-row'}>
                                <div className="info-label">Status</div>
                                <span className="info-text">
                                    {user.active ? 'Active' : 'Inactive'}
                                </span>
                                <Switch
                                    disableRipple={true}
                                    checked={user.active}
                                    onChange={() =>
                                        this.props.toggleUserActive(
                                            !user.active
                                        )
                                    }
                                />
                            </span>

                            <span className={'user-row'}>
                                <div className="info-label">Email</div>
                                <span className="info-text">{user.email}</span>
                            </span>

                            <span>
                                <span className="info-label">Teams</span>
                                <div className={'user-teams'}>
                                    {user.belongsInTeams.length ? (
                                        user.belongsInTeams.map(team => (
                                            <span
                                                key={team.id}
                                                className={'info-text'}
                                            >
                                                {team.name}
                                            </span>
                                        ))
                                    ) : (
                                        <span className={'empty-list'}>
                                            No teams
                                        </span>
                                    )}
                                </div>
                            </span>

                            <span>
                                <span className="info-label">Permissions</span>
                                <div className={'user-permissions'}>
                                    {permissions.length ? (
                                        permissions.map(permission => (
                                            <span
                                                key={permission}
                                                className={'info-text'}
                                            >
                                                {PermissionPipe(permission)}
                                            </span>
                                        ))
                                    ) : (
                                        <span className={'empty-list'}>
                                            No permissions
                                        </span>
                                    )}
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>Loading...</div>
        );
    };

    render() {
        return (
            <ContentBox
                contentBoxStyle={'content-box no-margin'}
                title="User Info"
                content={this.makeUserInfoContent()}
            />
        );
    }
}
